import type { ProductCarouselItem } from '@noths/polaris-design-system-candidate-components';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type { CatalogServiceProductData } from 'src/services/catalog/types';
import { transformProductModelToProduct } from 'src/utils/catalogProductToProduct';

/**
 * One carousel item is one card's props: the product itself plus the flags that
 * are presentation rather than properties of the product.
 */
export const transformProductModelToProductCarouselItem = (
  product: CatalogServiceProductData,
  { currency, priority }: { currency: CurrencyCode; priority: boolean },
): ProductCarouselItem => ({
  isNew: product.isNew,
  priority,
  product: transformProductModelToProduct(product, { currency }),
  /* Constant, not `product.onSale`. Every discount the catalog expresses is a
     price reduction rather than a code-based offer, and the card this replaces
     styled all of them as a sale, so there is no per-product decision to make
     here. `promoteAsSale` does nothing on a product with no discount, so it does
     not need guarding. */
  promoteAsSale: true,
});
